import { useState } from "react";
import { Label } from "reactstrap";
import Select from "react-select";
import {
  SelectOptionBooleanType,
  SelectOptionType,
} from "../models/GlobalModels";
import "./SearchBox.css";
import "./SelectBox.css";

interface ISelectBoxProps {
  options: any;
  label?: string;
  className?: string;
  value?: SelectOptionType | SelectOptionBooleanType | null;
  closeMenuOnSelect?: boolean;
  isMulti?: boolean;
  onChange?: (event: any) => void;
  customStyles?: any;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean; // Add the required prop
}

const SelectBox: React.FunctionComponent<ISelectBoxProps> = ({
  options,
  label,
  className,
  value,
  closeMenuOnSelect,
  onChange,
  isMulti,
  customStyles,
  placeholder,
  disabled,
  required, // Destructure the required prop
}) => {
  const [isClearable, setClearable] = useState<boolean>(false);

  // Custom styles for the dropdown
  const defaultCustomStyles = {
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      color: '#5C79AA',
      '&:hover': {
        color: '#5C79AA',
      },
      '&::after': {
        content: '""',
        width: 0,
        height: 0,
        borderLeft: '4px solid transparent',
        borderRight: '4px solid transparent',
        borderTop: '6px solid #5C79AA',
        marginLeft: '4px',
        transition: 'transform 0.2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      },
      svg: {
        display: 'none',
      },
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '8px',
      border: '1px solid #B6C4E3',
      '&:hover': {
        border: '1px solid #B6C4E3',
      },
    }),
    menu: (provided: any) => ({
      ...provided,
      fontSize: '11px',
      border: '1px solid #B6C4E3',
      borderRadius: '8px',
      overflow: 'hidden',
      zIndex: 2000,
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 2000,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      fontSize: '11px',
      backgroundColor: state.isSelected ? '#f0f4f8' : 'white',
      color: '#5C79AA',
      '&:hover': {
        backgroundColor: '#f0f4f8',
      },
      borderBottom: '1px solid #B6C4E3',
    }),
    singleValue: (provided: any) => ({
      ...provided,
      fontSize: '11px',
      color: '#5C79AA'
    }),
    placeholder: (provided: any) => ({
      ...provided,
      fontSize: '11px',
      color: '#5C79AA'
    }),
    input: (provided: any) => ({
      ...provided,
      fontSize: '11px',
      color: '#5C79AA'
    }),
  };

  // Merge custom styles with default styles
  const mergedStyles = customStyles ? { ...defaultCustomStyles, ...customStyles } : defaultCustomStyles;

  return (
    <div className="mb-2">
      {label && (
        <Label className="mb-1 text-start search-label text-muted">
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </Label>
      )}
      <div className={`close ${className}`}>
        <Select
          styles={mergedStyles}
          isMulti={isMulti ? isMulti : false}
          closeMenuOnSelect={!closeMenuOnSelect ? closeMenuOnSelect : true}
          value={value}
          options={options}
          onChange={onChange}
          placeholder={placeholder}
          isDisabled={disabled}
          onFocus={() => {
            setClearable(true);
          }}
          onBlur={() => {
            setClearable(false);
          }}
          isClearable={isClearable}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          menuShouldScrollIntoView={false}
        />
      </div>
    </div>
  );
};

export default SelectBox;
